import { render, staticRenderFns } from "./captcha-modal.vue?vue&type=template&id=44bf15b6&scoped=true"
import script from "./captcha-modal.vue?vue&type=script&lang=js"
export * from "./captcha-modal.vue?vue&type=script&lang=js"
import style0 from "./captcha-modal.vue?vue&type=style&index=0&id=44bf15b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bf15b6",
  null
  
)

export default component.exports